import { InjectionToken } from '@angular/core';

export const SALES_APS_SERVICE = new InjectionToken<any>('SalesApsService');
